import { Player } from '@lottiefiles/react-lottie-player'
import React, { useEffect, useRef, useState } from 'react'

const defaultOptions = {
    loop: true,
    autoplay: true,
    speed: 0.5,
}

const ControlledLottieAnimation = ({ src, style, loops = 1, ...rest }) => {
    const [repetitions, setRepetitions] = useState(0)

    const ref = useRef(null)

    const onEvent = e => {
        if (e == 'loop') {
            setRepetitions(rep => rep + 1)
        }
    }

    useEffect(() => {
        if (repetitions === loops) {
            ref.current.stop()
        }
    }, [repetitions])

    return (
        <Player
            ref={_ref => (ref.current = _ref)}
            onEvent={onEvent}
            style={style}
            src="/assets/revamp/gestures/raise-hand.json"
            {...defaultOptions}
            {...rest}
        />
    )
}

export default ControlledLottieAnimation
